import React from 'react';
import OrgRow from './OrgRow/index';

const OrgList = ({
    data,
    addFavouriteOrg,
    onOrgSelect,
    onSaveOrg,
    onDeleteOrg,
    showOrgLoader,
    onEmpDashboard,
    onOrgSurveyDashboard,
    onProjectDashboard,
    onImpersonateOrg,
    onClearSelectedObjects
}) => {
    return (
        <div className="app-main-content">
            {data.map((data, index) =>
                <OrgRow key={index} organisation={data} onDeleteOrg={onDeleteOrg}
                    onSaveOrg={onSaveOrg} showOrgLoader={showOrgLoader}
                    addFavouriteOrg={addFavouriteOrg} onOrgSelect={onOrgSelect}
                    onEmpDashboard={onEmpDashboard} onOrgSurveyDashboard={onOrgSurveyDashboard}
                    onProjectDashboard={onProjectDashboard} onImpersonateOrg={onImpersonateOrg}
                    onClearSelectedObjects={onClearSelectedObjects}
                />
            )}

        </div>
    );
};

export default OrgList;


// WEBPACK FOOTER //
// ./components/Agile/Organisation/OrgList/index.js